import pathsToCoords from './utils/pathsToCoords';
import getFillCoords from './utils/getFillCoords';

export default function (paths, scale, numPoints, translateX, translateY, fill) {
	const flatCoords = pathsToCoords(paths, scale, numPoints, translateX, translateY);
	if(fill){
		const fillCoords = getFillCoords(flatCoords, numPoints);
		return fillCoords;
	} else {
		return flatCoords;
	}
}